import { integrationsClient } from '~/api/client';
import { endpoints } from '~/api/endpoints';

import type {
  TriggerSyncRequest,
  TriggerSyncResponse,
  WorkflowStatusResponse,
} from '../types/catalog-import.types';
import type { ApiResponse } from '../types/connection.types';

/** Trigger a data-quality sync workflow (GMC → quality score → ClickHouse).
 *  Returns the workflow ID we then poll via `getWorkflowStatus`. */
export async function startProductSync(body: TriggerSyncRequest): Promise<TriggerSyncResponse> {
  const res = await integrationsClient
    .post(endpoints.products.sync(), { json: body })
    .json<ApiResponse<TriggerSyncResponse>>();
  return res.data;
}

/** Poll a workflow's status + live progress. Safe to call after a sync
 *  trigger; returns the terminal state (COMPLETED/FAILED/CANCELLED) once done. */
export async function getWorkflowStatus(workflowId: string): Promise<WorkflowStatusResponse> {
  const res = await integrationsClient
    .get(endpoints.workflows.status(workflowId))
    .json<ApiResponse<WorkflowStatusResponse>>();
  return res.data;
}
